import { ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA } from '../types'

export default function adicionarDadosPagamentoEncomenda (dadosPagamento) {
  return {
    type: ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA,
    payload: dadosPagamento
  }
}
